export default __webpack_public_path__ + "static/media/login-bg.9843d85a.jpg";